module.exports = __webpack_public_path__ + "img/lunbo102.465ec72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo102.png
// module id = o5KC
// module chunks = 0